'use client';

import { PopperClickAwayClose } from './PopperClickAwayClose';
import { PopperConsumer } from './PopperConsumer';
import { PopperDisplay } from './PopperDisplay';
import { PopperHoverEnter } from './PopperHoverEnter';
import { PopperHoverLeave } from './PopperHoverLeave';
import { PopperIsOpen } from './PopperIsOpen';
import { PopperOnClickClose } from './PopperOnClickClose';
import { PopperProvider } from './PopperProvider';
import { PopperToggle } from './PopperToggle';

type PopperCompound = typeof PopperProvider & {
  Display: typeof PopperDisplay;
  Toggle: typeof PopperToggle;
  Enter: typeof PopperHoverEnter;
  Leave: typeof PopperHoverLeave;
  IsOpen: typeof PopperIsOpen;
  OnClickClose: typeof PopperOnClickClose;
  ClickAwayClose: typeof PopperClickAwayClose;
  Consumer: typeof PopperConsumer;
};

///
// provides management of the anchor element and open/close state of the PopoverDisplay
// requires a <AnchorElement> to consume event handler
//
// @example
// ```jsx
//    <popper>
//      <popper.Toggle>
//        <HTMLElement/>
//      </popper.Toggle>
//      <popper.Display>
//        ...
//      </popper.Display>
//    </popper>
//
//    <popper>
//      <popper.Leave>
//        <span>
//          <popper.Enter>
//            <HTMLElement/>
//          </popper.Enter>
//          <popper.Display>
//            ...
//          </popper.Display>
//        <span>
//      </popper.Leave>
//    </popper>
// ```
//
export const Popper: PopperCompound = Object.assign( PopperProvider, {
  Display: PopperDisplay,
  Toggle: PopperToggle,
  Enter: PopperHoverEnter,
  Leave: PopperHoverLeave,
  IsOpen: PopperIsOpen,
  OnClickClose: PopperOnClickClose,
  ClickAwayClose: PopperClickAwayClose,
  Consumer: PopperConsumer,
} );
